module.exports = __webpack_public_path__ + "img/fusion-capacitor.18e39af2.png";